import type { CharacterActionKey } from "@/character/actions";
import type { CharacterGridSpec } from "@/character/grid";
import type { StatAllocation } from "@/game/model/character-stats";
import { emptyAllocation } from "@/game/model/character-stats";

export type ShadowDefinition = {
  id: string;
  name: string;
  createdAt: number;
  spritesheetDataUrl: string;
  grid: CharacterGridSpec;
  actions: Record<CharacterActionKey, string>;
  /** AP cards permanently applied to this shadow. */
  apCardsApplied: number;
  statAllocation: StatAllocation;
};

export type ShadowPlayerState = {
  version: 1;
  equippedId: string | null;
  shadows: ShadowDefinition[];
};

export function createEmptyShadowState(): ShadowPlayerState {
  return { version: 1, equippedId: null, shadows: [] };
}

export function emptyShadowAllocation(): StatAllocation {
  return emptyAllocation();
}
